import React from 'react';

const font = "'DM Sans', sans-serif";

const items = [
  { id: 'sala', icon: '🏛️', label: 'Sala', path: '/sala' },
  { id: 'ideas', icon: '💭', label: 'Ideas', path: '/mis-ideas' },
  { id: 'matches', icon: '⭐', label: 'Matches', path: '/matches' },
  { id: 'chats', icon: '💬', label: 'Chats', path: '/conexiones' },
  { id: 'perfil', icon: '👤', label: 'Perfil', path: '/perfil' },
];

export default function MobileBottomNav({ active, navigate }) {
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'rgba(10,10,15,0.95)', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)',
      borderTop: '0.5px solid rgba(255,255,255,0.05)',
      display: 'flex', justifyContent: 'space-around',
      padding: '10px 0 env(safe-area-inset-bottom, 8px)',
      zIndex: 50, fontFamily: font,
    }}>
      {items.map(item => (
        <div
          key={item.id}
          onClick={() => navigate(item.path)}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
            padding: '4px 12px', cursor: 'pointer',
            color: active === item.id ? '#5dc1b9' : 'rgba(255,255,255,0.35)',
            transition: 'color 0.2s',
          }}
        >
          <span style={{ fontSize: 20 }}>{item.icon}</span>
          <span style={{ fontSize: 10, fontWeight: active === item.id ? 600 : 400 }}>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
